import { bold } from './ansiHelpers.js';
import { bulletedList } from './bulletedList.js';
import { defaultLoggingConfig } from './loggingConfigs.js';
import { TaskReporter } from './TaskReporter.js';

//const allIntervals: Set<NodeJS.Timer> = [];
const allTimeouts = new Set<NodeJS.Timeout>();

// function interval(cb: () => void, ms: number) {
//   const id = setInterval(() => cb);
//   allIntervals.add(id);
// }

function timeout(cb: () => void, ms: number): void {
  const id = setTimeout(() => {
    allTimeouts.delete(id);
    cb();
  }, ms);

  allTimeouts.add(id);
}

function cleanup(): void {
  allTimeouts.forEach(clearTimeout);
  allTimeouts.clear();

  // allIntervals.forEach(clearInterval);
  // allIntervals.clear();
}

function start(): void {
  let count = 0;
  const activeTasks = new Set();

  // Set up a task logger:
  const taskReporter = new TaskReporter({
    productName: `Cloudpack`,
    version: `1.2.3`,
    description: `running tasks with ${bold(`15`)} workers`,
    ...defaultLoggingConfig,
  });

  const addMoreTasks = (): void => {
    if (activeTasks.size < 3) {
      const tasksToAdd = Math.max(2, Math.round(Math.random() * 40));

      for (let i = 0; i < tasksToAdd; i++) {
        const timeToStart = Math.round(Math.random() * 4000);
        const timeToComplete = Math.max(2000, Math.round(Math.random() * 2000));
        const taskShouldPass = Math.random() > 0.5;

        const runningTask = taskReporter.addTask(`Task ${++count}`, true);

        activeTasks.add(runningTask);

        timeout(() => {
          runningTask.start();

          timeout(() => {
            activeTasks.delete(runningTask);

            runningTask.complete(
              taskShouldPass
                ? undefined
                : {
                    status: 'fail',
                    message: 'Reason',
                    details: bulletedList(['Detail 1', 'Detail 2']),
                  },
            );

            if (activeTasks.size === 0) {
              taskReporter.complete({ summary: 'All tasks complete' });
            }
          }, timeToComplete);
        }, timeToStart);
      }
    }
  };

  addMoreTasks();

  // allIntervals.push(
  //   setInterval(addMoreTasks, 1000),
  //   setInterval(() => console.log('I am a console.log message.'), 1000),
  //   setInterval(() => console.info('I am a console.info message.'), 2000),
  //   setInterval(() => console.warn('I am a console.warn message.'), 3000),
  //   setInterval(() => console.error('I am a console.error message.'), 4000),
  // );

  // When ctrl-c is pressed, stop the task logger and print summary.
  process.on('SIGINT', () => {
    try {
      taskReporter.complete({ summary: 'User canceled' });
    } catch (err) {
      console.error('Error during task completion:', err);
    } finally {
      cleanup();
    }
  });
}

start();
